
function calculateUpgradeRequirements(currentTier, currentTierAmountSpent, nextTierAmountNeeded) {
  const tierThresholds = {
    bronze: 25000,
    silver: 35000,
    gold: 50000,
    'black-platinum': 100000
  };

  const tierOrder = ['bronze', 'silver', 'gold', 'black-platinum'];
  const currentTierHandle = currentTier?.replaceAll(' ', '-').toLowerCase();
  const currentTierIndex = tierOrder.indexOf(currentTierHandle);

  if (currentTierIndex === -1) return {};

  const upgradeRequirements = {};

  tierOrder.forEach((tier, index) => {
    if (index <= currentTierIndex) {
      upgradeRequirements[tier] = 0;
    } else if (index === currentTierIndex + 1) {
      upgradeRequirements[tier] = nextTierAmountNeeded;
    } else {
      const nextTierThreshold = tierThresholds[tierOrder[currentTierIndex + 1]];
      const targetTierThreshold = tierThresholds[tier];
      upgradeRequirements[tier] = nextTierAmountNeeded + (targetTierThreshold - nextTierThreshold);
    }
  });

  return upgradeRequirements;
}

async function getYotpoData(email) {
  try {
    if (email) {
      const res = await fetch(`https://nec-yotpo-loyalty-g7abcqezgaa7g4gf.eastus-01.azurewebsites.net/api/profile?email=${email}`);
      const data = await res.json();

      const upgradeRequirements = calculateUpgradeRequirements(
        data?.vip_tier_name,
        data?.current_tier_amount_spent || 0,
        data?.vip_tier_upgrade_requirements?.amount_cents_needed || 0
      );

      return {
        tier: data?.vip_tier_name || '',
        points: data?.points_balance || 0,
        currentTierAmountSpent: data?.vip_tier_actions_completed?.amount_spent_cents || 0,
        nextTierAmountNeeded: data?.vip_tier_upgrade_requirements?.amount_cents_needed || 0,
        upgradeRequirements
      };
    }

    return {
      tier: null,
      points: null,
      currentTierAmountSpent: null,
      nextTierAmountNeeded: null,
      upgradeRequirements: null
    }
  } catch (error) {
    console.error(error);
  }
}

function initializeLoyaltyData() {
  const email = window?.customer?.email
  getYotpoData(email).then(data => {
    window.loyaltyExclusiveData = data;
    document.dispatchEvent(new CustomEvent('loyalty-exclusive:loaded'));
    document.querySelectorAll('loyalty-exclusive-slider').forEach(slider => {
      if (slider.loadTierAvailability) {
        slider.loadTierAvailability();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLoyaltyData);
} else {
  initializeLoyaltyData();
}
window.addEventListener('ne:customer-state', initializeLoyaltyData);


class LoyaltyExclusiveHeader extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.loy-exc__header')
    this.pointsText = this.querySelector('[data-loyalty-points]')
    this.badge = this.querySelector('[data-loyalty-badge]')
    this.tierText = this.querySelector('[data-loyalty-tier]')
    this.tierBars = Array.from(this.querySelectorAll('.loy-exc__header_bar'))
    this.badges = {
      'bronze': 'https://cdn.shopify.com/s/files/1/0601/2554/4675/files/a2c74bccbac938beac0044ca92feb207516a5174.png?v=1764951592&width=250',
      'silver': 'https://cdn.shopify.com/s/files/1/0601/2554/4675/files/bdf28a24bd44d302ec579e6f1c207e6b75123098.png?v=1764951589&width=250',
      'gold': 'https://cdn.shopify.com/s/files/1/0601/2554/4675/files/75263c3f69b7e992ce137ae5fa78d611b5a537e0.png?v=1764951588&width=250',
      'black-platinum': 'https://cdn.shopify.com/s/files/1/0601/2554/4675/files/738b0d9a1cbbcc3877789c3ad026d34c70d000ab.png?v=1764951586?v=1764951592&width=250',
    }
    this.gradients = {
      bronze: 'linear-gradient(180deg, #252320 0%, #373228 67.31%, #625740 100%)',
      silver: 'linear-gradient(180deg, #171717 0%, #3E3E3E 69.23%, #746F6F 100%)',
      gold: 'linear-gradient(180deg, #252320 0%, #563B14 67.31%, #7D5824 100%)',
      'black-platinum': 'linear-gradient(180deg, #131313 0%, #1A1A1A 100%)'
    }
    this.limits = {
      bronze: 25000,
      silver: 35000,
      gold: 50000,
      'black-platinum': 100000
    }

    document.addEventListener('loyalty-exclusive:loaded', () => {
      this.renderTierData()
    })
  }

  renderTierData() {
    const data = window?.loyaltyExclusiveData
    if (data) {
      const strings = window.themeStrings ?? {}
      const tierHandle = data?.tier && data.tier.replaceAll(' ', '-')?.toLowerCase()

      this.pointsText.textContent = (strings.pointsCount ?? '{{ points }} points').replace('{{ points }}', data.points)

      if (tierHandle) {
        this.container.style.background = this.gradients[tierHandle]
        this.tierText.textContent = data.tier
        this.badge.innerHTML = `<img src="${this.badges[tierHandle]}" width="250" height="250"/>`
      } else{
        this.tierText.textContent = strings.loyaltyPreTierMessage ?? 'Start shopping to earn points towards Bronze level status'
      }

      if (tierHandle === 'bronze') {
        const width = (this.limits.silver - data.nextTierAmountNeeded) / this.limits.silver * 100
        this.tierBars[0]?.style?.setProperty('--tier-bar-width', `${width}%`)
      } else if (tierHandle === 'silver') {
        const width = (this.limits.gold - data.nextTierAmountNeeded) / this.limits.gold * 100
        this.tierBars[0]?.style?.setProperty('--tier-bar-width', `100%`)
        this.tierBars[1]?.style?.setProperty('--tier-bar-width', `${width}%`)
      } else if (tierHandle === 'gold') {
        const width = (this.limits['black-platinum'] - data.nextTierAmountNeeded) / this.limits['black-platinum'] * 100
        this.tierBars[0]?.style?.setProperty('--tier-bar-width', `100%`)
        this.tierBars[1]?.style?.setProperty('--tier-bar-width', `100%`)
        this.tierBars[2]?.style?.setProperty('--tier-bar-width', `${width}%`)
      } else if (tierHandle === 'black-platinum') {
        this.tierBars.forEach(bar => bar?.style?.setProperty('--tier-bar-width', `100%`))
      }
    }
  }
}
customElements.define('loyalty-exclusive-header', LoyaltyExclusiveHeader);

class LoyaltyExclusiveSlider extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.loy-exc-slider__carousel');
    this.slider = this.querySelector('.swiper');
    this.cards = this.querySelectorAll('.swiper .custom-collection--product');
    this.memberButtons = Array.from(this.cards, (card) => {
      const container = card.querySelector('product-form .new-product-form__buttons');
      return container ? { container, children: Array.from(container.childNodes) } : null;
    }).filter(Boolean);
    this.prevArrow = this.querySelector('.loy-exc-slider__navigation .prevArrow');
    this.nextArrow = this.querySelector('.loy-exc-slider__navigation .nextArrow');
    this.tier = this.getAttribute('data-loyalty-tier');
    this.tiersUpgradeRequirements = {
      bronze: 25000,
      silver: 35000,
      gold: 50000,
      'black-platinum': 100000
    }

    this.loadSwiper();

    document.addEventListener('loyalty-exclusive:loaded', () => {
      this.loadTierAvailability();
    });
  }

  loadTierAvailability() {
    // Resolve the customer's tier to a canonical handle by keyword, so Yotpo
    // tier-name variants ("Bronze", "Bronze Tier", "New Era Rewards Bronze")
    // all map correctly instead of failing an exact match (which would lock a
    // qualifying member out of their own tier).
    const rawTier = (window?.loyaltyExclusiveData?.tier || '').toLowerCase();
    let storedTier = rawTier.replaceAll(' ', '-');
    if (rawTier.includes('black') || rawTier.includes('platinum')) storedTier = 'black-platinum';
    else if (rawTier.includes('gold')) storedTier = 'gold';
    else if (rawTier.includes('silver')) storedTier = 'silver';
    else if (rawTier.includes('bronze')) storedTier = 'bronze';
    const tierOrder = ['bronze', 'silver', 'gold', 'black-platinum'];

    if (!window?.customer?.email) {
      this.container.style.opacity = 1;
      this.container.style.pointerEvents = 'auto';
      this.cards?.forEach(card => {
        const button = card?.querySelector('product-form .new-product-form__buttons')
        if (button) {
          button.innerHTML = `<a href="/account/login?return_to=${window.location.pathname}" class="new-product-form__submit button button--full-width button--secondary">${window.themeStrings?.login ?? 'Login'}</a>`
        }
      })
    } else {
      this.memberButtons.forEach(({ container, children }) => container.replaceChildren(...children));
      const currentTierIndex = tierOrder.indexOf(storedTier);
      const sliderTierIndex = tierOrder.indexOf(this.tier);
      const tierName = this.tier?.replaceAll('-', ' ')

      // sliderTierIndex is -1 for the 'all' setting: a slider open to every
      // signed-in member, with no tier requirement to check and no lock to show.
      if (sliderTierIndex === -1 || currentTierIndex >= sliderTierIndex) {
        this.container.style.opacity = 1;
        this.container.style.pointerEvents = 'auto';
      } else {
        const amountNeeded = window?.loyaltyExclusiveData?.upgradeRequirements?.[this.tier] || this.tiersUpgradeRequirements?.[this.tier]
        if (amountNeeded) {
          this.cards?.forEach(card => {
            const button = card?.querySelector('product-form button[type="submit"]')
            if (button) {
              button.innerHTML = ` <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d="M15 8.134V6.4375C15 3.02575 12.2242 0.25 8.8125 0.25C5.40075 0.25 2.625 3.02575 2.625 6.4375V8.134C1.5 8.23 0.375 9.2815 0.375 10.5618V17.3118C0.375 18.6558 1.446 19.75 2.79 19.75H14.7904C16.1344 19.75 17.25 18.6558 17.25 17.3118V10.5618C17.25 9.28113 16.125 8.23038 15 8.134ZM15.375 17.3118C15.375 17.6166 15.0953 17.875 14.7904 17.875H2.79037C2.48513 17.875 2.25 17.6163 2.25 17.3118V10.5618C2.25 10.2569 2.4855 10 2.79 10H4.5V6.4375C4.5 4.05962 6.43425 2.125 8.8125 2.125C11.1908 2.125 13.125 4.05962 13.125 6.4375V8.125H6V10H14.7904C15.0953 10 15.375 10.2569 15.375 10.5618V17.3118ZM8.8125 11.8743C7.20638 11.8743 6.4575 14.0095 7.875 14.944C7.88438 14.9507 7.89263 14.9586 7.902 14.965V16.375H9.723V14.965C9.73238 14.9586 9.74063 14.9507 9.75 14.944C11.1675 14.0087 10.4186 11.8743 8.8125 11.8743Z" fill="black"/>
    </svg><span>${(window.themeStrings?.loyaltyTierOnly ?? '{{ tier }} only').replace('{{ tier }}', tierName.charAt(0).toUpperCase() + tierName.slice(1))}</span>`
            }
          })
        }
      }

    }
  }

  loadSwiper() {
    new Swiper(this.slider, {
      spaceBetween: 8,
      slidesPerView: 'auto',
      breakpoints: {
        0: {
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          navigation: {
            enabled: false,
          },
        },
        768: {
          slidesOffsetAfter: 80,
          slidesOffsetBefore: 80,
          navigation: {
            enabled: true,
          },
        },
        1928: {
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      },
      navigation: {
        prevEl: this.prevArrow,
        nextEl: this.nextArrow,
      },
    });
  }
}

customElements.define('loyalty-exclusive-slider', LoyaltyExclusiveSlider)
